import { toLocalizedRiotUrl } from './../utils/language';
import config from './config';
import history from '../../app_react/history';

export default new (function() {
    this.goToDraft = function(draftId) {
        if (draftId) {
            history.push('draft/' + draftId);
        } else {
            history.push('draft/');
        }
    };

    this.goToStart = function() {
        if (config.isReactComponentsEnabled) {
            history.push(toLocalizedRiotUrl('/selling/'));
        } else {
            history.push('/');
        }
    };

    this.goToSummary = function(draftId, fromPage) {
        if (fromPage) {
            history.push('summary/' + draftId + '?from=' + fromPage);
        } else {
            history.push('summary/' + draftId);
        }
    };

    this.goToTemplates = function() {
        history.push('templates');
    };

    this.goToTemplate = function(templateId) {
        if (templateId) {
            history.push('template/' + templateId);
        } else {
            history.push('template/');
        }
    };

    this.goToPublished = function(itemId) {
        if (config.isReactComponentsEnabled) {
            history.push(toLocalizedRiotUrl('/selling/published/' + itemId));
        } else {
            history.push('published/' + itemId);
        }
    };

    this.goToEdit = function(draftId, propertyNames) {
        history.push('draft/' + draftId + '/edit/' + propertyNames);
    };

    this.goToEditTemplate = function(draftId, propertyNames) {
        history.push('template/' + draftId + '/edit/' + propertyNames);
    };

    this.setDraftUrlWithoutReload = function(draftId) {
        window.history.replaceState(
            {},
            document.title,
            toLocalizedRiotUrl('/selling/draft/' + draftId)
        );
    };
})();
